import styled from 'styled-components'
import { useSelector } from 'react-redux'
import RowReventa from './rowReventa.jsx'

import { useMemo } from "react";

let Container=styled.div`
	color:white;
	height:81%
`;

let ContainerReventas=styled.div`
	height:100%;
	overflow:auto;
	&::-webkit-scrollbar{
		background-color:transparent;
		width:3px
	};
	&::-webkit-scrollbar-track{
		background:trasparent;		
		border-radius:25px
	};
	&::-webkit-scrollbar-thumb {
    	background: #27B0FE;
    	border-radius: 15px;
  	};
  	&::-webkit-scrollbar:horizontal{display:none}

`

export default function ReventasPublicadas(){
	let reventasRedux=useSelector(state=>state.reventa.reventas);
	let filtro=useSelector(state=>state.usuario.userFilter);

	const visibleRows = useMemo(
    () =>{
     return reventasRedux
      	.filter(ele=>{
      		return(      			
            	ele.id.toLowerCase().includes(filtro.toLowerCase())
      			||ele.User.name.toLowerCase().includes(filtro.toLowerCase())
      			||ele.User.usuario.toLowerCase().includes(filtro.toLowerCase())
            	||ele.Cuenta_Juego.Cuentum.playstation_id.toLowerCase().includes(filtro.toLowerCase())
      			||ele.Cuenta_Juego.Cuentum.correo.toLowerCase().includes(filtro.toLowerCase())      			
      		)
      	})    
    },[filtro,reventasRedux]
  );

	return(
		<Container>
			{visibleRows?
				<ContainerReventas>
					{visibleRows.map(reventa=>reventa.publicar_reventa&&!reventa.vendido?<RowReventa data={reventa}/>:null)}
				</ContainerReventas>
			:null}
		</Container>
		)
}